<style lang="scss">
  .flip-card {
    background-color: transparent;
    width: 100%;
    max-width: 800px;
    perspective: 1000px;

    &.active {
      .flip-card-inner {
        transform: rotateY(180deg);

        .flip-icon{
          @include positioningOffset(absolute, 10px, unset, unset, 10px);
        }
      }
    }

    .flip-card-inner {
      position: relative;
      width: 100%;
      height: 100%;
      min-height: 500px;
      transition: transform 0.6s;
      transform-style: preserve-3d;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      // background-color: #D9D9D9;
      border-radius: 10px;

      .flip-icon{
        @include positioningOffset(absolute, 10px, 10px, unset, unset);
        @include flex(50px, flex, center, center);
        z-index: 1;
        color: white;
        font-size: 22pt;
        padding: 5px;
        background-color: rgba(0,0,0,0.4);
        height: 50px;
        border-radius: 10px;
      }

      .flip-card-front, .flip-card-back {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
      }

      #postcard-message {
        max-height: 400px;
        overflow-y: auto;
      }

      .flip-card-front {
        height: 100%;
        width: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .flip-card-back {
        transform: rotateY(180deg);
      }
    }
  }
</style>

<template>
  <article class="flip-card pointer" @click="active = !active" :class="{'active': active || backOnly}">
    <div class="flip-card-inner">
      <span v-if="!backOnly" class="flip-icon pointer"><i class="fas fa-undo"></i></span>
      <b-card class="flip-card-front p-2">
        <img :src="post.image_url" alt="">
      </b-card>
      <b-card class="flip-card-back p-2">
        <div class="row">
          <section class="col-12">
            <p id="postcard-message" v-html="post.message"></p>
          </section>
        </div>
      </b-card>
    </div>
  </article>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    components: {},
    props: {
      post: {
        required: true,
        type: Object,
      },
      backOnly: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        active: false,
      };
    },
    computed: {
      ...mapState({}),
    },
    watch: {},
    mounted() {},
    methods: {},
  };
</script>
